import { render, staticRenderFns } from "./ParametrosFisc.vue?vue&type=template&id=0dbfd503&"
import script from "./ParametrosFisc.vue?vue&type=script&lang=js&"
export * from "./ParametrosFisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports